import React from 'react';
import { Text, Divider } from '@lana-ui/common';
import '@styles/Features/plan-checkout.scss';

const PlanCheckout = ({ mesProporcional, mesProporcionalPrecio, mesSuscripcion, mesSuscripcionPrecio, precioLuegoDeTiempo, mesesDescuento, datosPlan }) => {
    
    return (
        <div className="plan-checkout">
            <Text as="p" className="--arial" size="2xs">
                <span className="descripcion">Proporcional mes {mesProporcional}</span>
                <span>${mesProporcionalPrecio}</span>
            </Text>

            {mesSuscripcionPrecio !== 0 && (
                <Text as="p" className="--arial --mb-8" size="2xs">
                    <span className="descripcion">Suscripción mes {mesSuscripcion}</span>
                    <span>${mesSuscripcionPrecio}</span>
                </Text>
            )}
            <Divider className="--mb-8" />

            <Text as="p" className="--arial --font-bold" size="2xs">
                <span className="descripcion">Total</span>
                <span>${mesProporcionalPrecio + mesSuscripcionPrecio}</span>
            </Text>

            <Text className="--arial banner-recorda" size="4xs">
                Recordá que tu suscripción es de ${mesSuscripcionPrecio == 0 ? datosPlan.precio : mesSuscripcionPrecio} durante los primeros {mesesDescuento} meses, luego será de $
                {precioLuegoDeTiempo}
            </Text>
        </div>
    );
};

export default PlanCheckout;
